/**
 * notification.ts
 * Shared Zod contract for the in-app notification bell — SDD-lite, 23 jul 2026.
 *
 * ZERO Hono/Drizzle/infrastructure imports — Zod only.
 *
 * Spec: SDD-lite plan, 23 jul 2026 (campanita de notificaciones)
 */
import { z } from 'zod';

export const NotificationResponseSchema = z.object({
  id: z.string().uuid(),
  type: z.string(),
  // moduleKey of origin ('nomi' | 'locx' | 'compras' | 'sumi' | 'aplicativos') —
  // fix-notification-bell-scoping, design.md §1. Kept z.string() (not a closed
  // enum) since the module list is expected to grow as new product modules ship.
  module: z.string(),
  title: z.string(),
  body: z.string(),
  linkUrl: z.string(),
  // Migration 0184 (compras-solicitudes-visibilidad-alertas, Slice E) — the
  // table itself stays an open-vocabulary text column (mirrors `type`); this
  // is the ONE place the closed set is enforced (contract boundary).
  priority: z.enum(['low', 'medium', 'high', 'urgent']).nullable().optional(),
  // Migration 0030 — who triggered it ("Ana Pérez"); null for system events and older rows.
  actorLabel: z.string().nullable().optional(),
  // Migration 0034 (odd/tasks/notification-tasks.md): 'task' stays pending until
  // its item is resolved (resolvedAt), 'info' is read and dismissed.
  kind: z.enum(['info', 'task']).optional(),
  resolvedAt: z.string().datetime().or(z.date()).nullable().optional(),
  readAt: z.string().datetime().or(z.date()).nullable(),
  createdAt: z.string().datetime().or(z.date()),
});
export type NotificationResponse = z.infer<typeof NotificationResponseSchema>;
